/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { useStyles, InputContainer, InputItem } from './styles';
import { Divider, Typography, Box } from '@material-ui/core';
import { FastField, Field, Form, Formik } from 'formik';
import CustomTextField from 'shared/component/forms/CustomTextField';
import { InputMaskField } from 'shared/component/forms/CustomMaskField';
import { schema } from './schema';
import moment from 'moment';
import { useAuth } from 'hook/auth';
import { initialValues } from './initialValues';
import { AntTab, AntTabs } from 'shared/component/TabsComponents';
import HeaderForm from './components/HeaderForm';
import FooterButton from './components/FooterButton';
import CustomSelectProfilePermissions from 'shared/component/forms/CustomSelectProfilePermissions';
import CustomSelectUnits from 'shared/component/forms/CustomSelectUnits';
import CustomSelectScales from 'shared/component/forms/CustomSelectScales';
import TablePermissionsList from './TablePermissionsList';
import CustomSelectCompanies from 'shared/component/forms/CustomSelectCompanies';
import { Button, Text } from '@chakra-ui/react';
import useUser from 'hook/user';

export default function AdminForm({
  formInitialValues = initialValues,
  loading = false,
  isEdit = false,
  status,
  error,
  setError = () => {},
  message,
  formSubmit = () => {},
}) {
  const classes = useStyles();
  const { userLogged } = useAuth();
  const { recoverPass, msg } = useUser();

  const [currentTab, setCurrentTab] = useState(0);
  const [fileLogo, setFileLogo] = React.useState(null);

  const abas = [
    { id: 0, name: 'Informações pessoais' },
    { id: 1, name: 'Permissões' },
  ];

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleFormSubmit = (data) => {
    data.file = fileLogo;
    data.scales = data.escales || []; // Inclui o campo escales no envio
    data.scale_permission = data.scale_permission || false; // Garante que scale_permission seja enviado
    formSubmit({ data });
  };

  const getFormatedLabel = (item) => {
    return {
      value: item.id,
      label: item.name,
    };
  };

  const getInitialUnits = (units) => {
    return units.map((item) => getFormatedLabel(item));
  };

  return (
    <>
      <AntTabs
        value={currentTab}
        onChange={handleChangeTab}
        aria-label="ant example"
      >
        {abas
          .filter((item) => (!isEdit && item.id === 0) || isEdit)
          .map((option, i) => (
            <AntTab key={i} label={option.name} />
          ))}
      </AntTabs>
      <Divider style={{ marginBottom: 24, paddingTop: 2 }} />
      <Formik
        onSubmit={handleFormSubmit}
        validationSchema={schema}
        initialValues={formInitialValues}
        validateOnBlur
        enableReinitialize
      >
        {({
          setFieldValue,
          setFieldTouched,
          handleBlur,
          touched,
          values,
          errors,
        }) => {
          // Atualiza o campo escales com base em scales
          useEffect(() => {
            if (
              isEdit &&
              values.scales &&
              values.scales.length > 0 &&
              (!values.escales || values.escales.length === 0)
            ) {
              const formattedScales = values.scales.map((scale) => ({
                id: scale.id,
                name: scale.name,
              }));
              setFieldValue('escales', formattedScales);
            }
          }, [values.scales, isEdit, setFieldValue]);

          return (
            <Form>
              <div style={{ display: currentTab === 0 ? 'block' : 'none' }}>
                <HeaderForm
                  formInitialValues={formInitialValues}
                  setFileLogo={setFileLogo}
                />
                <div>
                  <Button
                    display="flex"
                    background="#BBE9F9"
                    border="1px solid #BBE9F9"
                    borderRadius={4}
                    fontWeight={400}
                    type="button"
                    onClick={() => {
                      if (values.email) {
                        recoverPass({ email: values.email });
                      }
                    }}
                  >
                    Resetar senha
                  </Button>
                  <Text>{msg}</Text>
                </div>
                <Typography className={classes.dataHospital}>
                  {!isEdit
                    ? 'Cadastrar novo administrador'
                    : 'Editar Administrador'}
                </Typography>
                <InputContainer>
                  <InputItem style={{ flexGrow: 1.02 }}>
                    <FastField
                      data-cy=""
                      label="Nome"
                      style={{ width: '100%' }}
                      name="name"
                      variant="outlined"
                      component={CustomTextField}
                    />
                  </InputItem>
                </InputContainer>
                <InputContainer data-cy="inputContainer">
                  <InputItem style={{ flexGrow: 1 }}>
                    <FastField
                      label="CPF"
                      style={{ width: '100%' }}
                      name="cpf"
                      format="999.999.999-99"
                      variant="outlined"
                      value={values?.cpf || null}
                      component={InputMaskField}
                      onChange={(e) => {
                        setFieldValue('cpf', e.target.value);
                      }}
                    />
                  </InputItem>
                  <InputItem style={{ flexGrow: 1 }}>
                    <FastField
                      name="cell_phone"
                      id="cell_phone"
                      style={{ width: '100%' }}
                      label="Telefone"
                      format="(99) 9 9999-9999"
                      variant="outlined"
                      component={InputMaskField}
                      value={values?.cell_phone || null}
                      onChange={(e) => {
                        setFieldValue('cell_phone', e.target.value);
                      }}
                    />
                  </InputItem>
                  <InputItem style={{ flexGrow: 2 }}>
                    <FastField
                      label="E-mail"
                      style={{ width: '100%' }}
                      name="email"
                      variant="outlined"
                      component={CustomTextField}
                    />
                  </InputItem>
                </InputContainer>
                <Typography className={classes.address}>
                  Informações administrativas
                </Typography>
                <InputContainer data-cy="inputContainer2">
                  <InputItem style={{ flexGrow: 1 }}>
                    {userLogged?.group?.id === 1 ? (
                      <Field
                        name="company.id"
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        errors={
                          errors && errors?.company && errors?.company?.id
                        }
                        style={{ width: '100%' }}
                        placeholder="Empresa responsável"
                        label="Empresa responsável"
                        value={
                          values &&
                          values.company &&
                          !!values.company?.id &&
                          values.company?.id !== ''
                            ? getFormatedLabel(values.company)
                            : null
                        }
                        handleChange={(e) => {
                          if (e?.value) {
                            setFieldValue('company.id', e.value);
                            setFieldValue('company.name', e.label);
                          } else {
                            setFieldValue('company.id', '');
                            setFieldValue('company.name', '');
                          }
                        }}
                        menuList={() => ({ height: 116, overflowY: 'auto' })}
                        variant="outlined"
                        touched={touched}
                        handleBlur={handleBlur}
                        component={CustomSelectCompanies}
                      />
                    ) : (
                      <Field
                        name="company.id"
                        style={{ width: '100%' }}
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        placeholder={'Companhia responsável'}
                        errors={errors && errors.company && errors.company.id}
                        label={'Companhia'}
                        value={
                          values && values.company && values.company.id !== ''
                            ? getFormatedLabel(values.company)
                            : null
                        }
                        handleChange={(e) => {
                          setFieldValue('company.id', e.value);
                          setFieldValue('company.name', e.label);
                        }}
                        menuList={() => ({ height: 116, overflowY: 'auto' })}
                        variant="outlined"
                        component={CustomSelectCompanies}
                      />
                    )}
                  </InputItem>
                  <InputItem style={{ flexGrow: 1 }}>
                    <Field
                      name="group.id"
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      errors={
                        errors && errors.enterprise && errors.enterprise.id
                      }
                      style={{ width: '100%' }}
                      placeholder="Grupo de permissões"
                      label="Grupo de permissões"
                      value={
                        values &&
                        values.group &&
                        !!values.group?.id &&
                        values.group?.id !== ''
                          ? getFormatedLabel(values.group)
                          : null
                      }
                      handleChange={(e) => {
                        if (e?.value) {
                          setFieldValue('group.id', e.value);
                          setFieldValue('group.name', e.label);
                        } else {
                          setFieldValue('group.id', '');
                          setFieldValue('group.name', '');
                        }
                      }}
                      menuList={() => ({ height: 116, overflowY: 'auto' })}
                      variant="outlined"
                      component={CustomSelectProfilePermissions}
                      touched={touched}
                      handleBlur={handleBlur}
                    />
                  </InputItem>
                </InputContainer>
                <InputContainer data-cy="inputContainer3">
                  <InputItem>
                    <Field
                      name="units"
                      style={{ width: '100%' }}
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      placeholder={'Hospitais permitidos'}
                      label={'Hospitais permitidos'}
                      errors={errors && errors.units}
                      value={
                        values && values?.units && values?.units.length > 0
                          ? getInitialUnits(values.units)
                          : null
                      }
                      handleChange={(data) => {
                        setFieldValue(
                          'units',
                          data.map((item) => ({
                            id: item.value,
                            name: item.label,
                          }))
                        );
                      }}
                      menuList={() => ({ height: 116, overflowY: 'auto' })}
                      variant="outlined"
                      component={CustomSelectUnits}
                      isMulti
                    />
                  </InputItem>
                </InputContainer>
                <InputContainer data-cy="inputContainer4">
                  <InputItem>
                    <label
                      style={{ display: 'flex', alignItems: 'center', gap: 10 }}
                    >
                      Permissão por escala
                      <FastField
                        name="scale_permission"
                        type="checkbox"
                        style={{ marginLeft: '2px' }}
                        checked={values?.scale_permission || false}
                        onChange={(e) => {
                          setFieldValue('scale_permission', e.target.checked);
                        }}
                      />
                    </label>
                  </InputItem>
                </InputContainer>
                {values?.scale_permission && (
                  <InputContainer data-cy="inputContainer5">
                    <InputItem>
                      <CustomSelectScales
                        name="escales"
                        placeholder="Escalas"
                        id="Escalas"
                        menuList={() => ({ height: 116, overflowY: 'auto' })}
                        value={
                          values.escales && Array.isArray(values.escales)
                            ? values.escales.map((item) => ({
                                value: item.id,
                                label: item.name,
                              }))
                            : []
                        }
                        unit_id={
                          values?.units?.length > 0
                            ? values.units.map((unit) => unit.id)
                            : []
                        }
                        showCount
                        isClearable
                        isMulti
                        handleChange={(selected) => {
                          // Garante que selected seja um array, mesmo que seja null
                          const newValues = selected
                            ? selected.map((item) => ({
                                id: item.value,
                                name: item.label,
                              }))
                            : [];
                          setFieldValue('escales', newValues);
                        }}
                      />
                    </InputItem>
                  </InputContainer>
                )}
              </div>
              <div style={{ display: currentTab === 1 ? 'block' : 'none' }}>
                <TablePermissionsList
                  setFieldValue={setFieldValue}
                  values={values}
                  isEdit={isEdit}
                />
              </div>
              <Box
                display="flex"
                alignItems="end"
                justifyContent="space-between"
                marginBottom="20px"
              >
                {formInitialValues?.created_at && (
                  <Box display="flex">
                    <Typography>
                      Este usuário foi criado no dia{' '}
                      {moment(formInitialValues.created_at).format(
                        'DD/MM/yyyy'
                      )}{' '}
                      às{' '}
                      {`${moment(formInitialValues.created_at).format(
                        'HH[h]mm'
                      )}`}
                    </Typography>
                    {formInitialValues?.creator_user?.name && (
                      <Typography style={{ marginLeft: '5px' }}>
                        por{' '}
                        <strong>{formInitialValues.creator_user.name}</strong>
                      </Typography>
                    )}
                  </Box>
                )}
                <div data-cy="footerButton" style={{ marginRight: 5 }}>
                  <FooterButton
                    id={values?.id}
                    type="submit"
                    loading={loading}
                    status={status}
                    error={error}
                    setError={setError}
                    message={message}
                  />
                </div>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
